import axios from 'axios';

/**
 * Add To Cart Request Handler.
 *
 * @param {int} productId Product Id.
 * @param {int} qty Product Quantity.
 * @param {Function} setCart Sets The New Cart Value
 * @param {Function} setIsAddedToCart Sets A Boolean Value If Product Is Added To Cart.
 * @param {Function} setLoading Sets A Boolean Value For Loading State.
 */
export const addToCart = (productId: any, qty = 1, selectedProduct: any, selectedFormat: any, idWpdm: any) => {

	const COCART_ADDITEM = 'https://affichemap.fr/wp-json/cocart/v2/cart/add-item';

	/*"variation":
		{
			"attribute_support": selectedProduct,
			"attribute_format": selectedFormat
		},
		"item_data": {
			"custom_file": idWpdm
		}*/

	axios.post(COCART_ADDITEM, {
		id: productId,
		quantity: "1",
		"variation":
		{
			"attribute_pa_support": selectedProduct,
			"attribute_pa_dimensions": selectedFormat
		},
		"item_data": {
			"custom_file": idWpdm
		}

	})
		.then((res) => {

			console.log("Ajouté au panier")
		})
		.catch(err => {
			console.log('err', err);
		});

};
